import React from 'react'
import PropTypes from 'prop-types'

const LinkedinIcon = (props) => {
  const { classes = 'w-w0' } = props
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      className={classes}
    >
      <rect width="20" height="20" fill="url(#pattern0_3180_21461)" />
      <defs>
        <pattern
          id="pattern0_3180_21461"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_3180_21461" transform="scale(0.0131579)" />
        </pattern>
        <image
          id="image0_3180_21461"
          width="76"
          height="76"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAMAAADwSaEZAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABXUExURUdwTFCx4CiXz0ao2SmYzyaXzy2a0SaXzyaXzy2Z0CaXzz6i1D2h0yeXz/////P5/GG02zCb0Pr8/pfM58rl83u/4YbE45zP6EGj1Lfc7+Hw+FWt2aLS6nd3RKAAAAANdFJOUwAInhGJtlTX7W73IjnpBp4WAAACkklEQVRYw7WY63qDIAyGPYAcFBVmW7W9/+ucTrEKqAHd92tq9z6EJCQkig5VZAwlmHBOcIJYVkShiouECkM0KeIAUmaTBvGRl/nxYsTFgSiC42JGxYkoi4EGEgEQyQAsGAqGSwRYUiTHJmLhJXywcynxYwlO0j1W7ssaNy7fSR0qAkSLW2zUa3NZ+t37umt+pIcXbBbS395NOajywCGTxfSXVpWTXvC1GdFbLIn9mVll1cIjZOOE+Lv5vYaph4cTnEYKUWlY+ePhUraKilWELSsrnz7RFtueHNQte/YWIUtbL0w8tDcb6ZUIqfPYeU60pvVLhDnYcuN13fR9/5G+B0huunI+9dpW+ucoM5Lykv5SNOX3wPjogkzcpMwuIY9FU5y1+nHyblsPf9ZOT4/lxThfzXSqVzH8fvVT3Kj+ZYU0p8N5IaAw2X2/Dc92UBdWYOzBVN2VW3UGTbJNXh7CmtJUZyVBAoQ5pGrTAzgcVn7MsCVeMKXWT/0VWFNL+V77YRtvNOJgmJqP3rraKRPcjNkDWKN/8topExRuplpskvo3qjNqFNibq91u3JGG4XG2+seXZfkcZ9AMWLcLTzcMgXNzvdk7MGadjRdgmVWbLsCG+kTughH72A6HJXZBCYeNBSXm98CmRgjfA8OO9iAYxhyNSzAstXu9YBhyNXuBsKXZ2ywtEIacDXIYjKag1h0GY+5LRaW0Ztj2cW57Z2kYid3XHbnIeLFpK7YvebFzEQsRuzA2OL0iXuiT8X9fq6M87MKf//8oYrDUe9+ORi5WSfb342ZI5XFf4adjqhxsKs4BE7QCNoyDTkbPB3KguR5s6gidOJ6MVkXAaHXePGSZS1D4EDlKx3k0JpQSPE6j0+Nf/wJhkO7ds+Qx+gAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  )
}

LinkedinIcon.propTypes = {
  classes: PropTypes.string,
}

export default React.memo(LinkedinIcon)
